import React from 'react';
import { DefaultButton, IContextualMenuProps } from '@fluentui/react';
import { ImageFit } from '@fluentui/react/lib/Image';
import { IbtnOptions } from '../CardContainer/cards';
import styles from './DropdownButton.module.css';
import { buttonStyles } from './StandardButton';

interface IStandardButtonProps {
    text: string;
    btnOptions: IbtnOptions[];
}

const DropdownButton: React.FC<IStandardButtonProps> = ({ text, btnOptions }) => {
    const items = btnOptions.map((option) => {
        let iconProps;
        if (option.iconType === 'icon') {
            iconProps = { iconName: option.icon, className: styles.icon };
        } else {
            iconProps = {
                className: styles.svgWrap,
                imageProps: {
                    src: option.icon,
                    imageFit: ImageFit.centerContain,
                    className: styles.svg,
                },
            };
        }

        return {
            key: option.text,
            text: option.text,
            iconProps,
            href: option.link(),
            target: '_blank',
            rel: 'noreferrer noopener',
        };
    });

    const menuProps: IContextualMenuProps = {
        items,
        isBeakVisible: false,
    };

    return <DefaultButton text={text} styles={buttonStyles} menuProps={menuProps} />;
};

export default DropdownButton;
